@if (isLoading) {
  <div class="loading-state">
    <p>Loading...</p>
  </div>
} @else {
  @if (data?.length) {
    @for (info of data; track info) {
      <div class="info-content">
        <div class="heading">
          <label>{{info.propertyName}}</label>
        </div>
        <div class="value">
          <p class="info">{{info.propertyValue}}</p>
          <div class="line"></div>
        </div>
      </div>
    }
  } @else {
    <div class="no-record">
      <p>No Records</p>
    </div>
  }
}